const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateLoginForm = (email: string, password: string) => ({
	isEmailValid: EMAIL_REGEX.test(email),
	isPasswordValid: password.length >= 8,
});

export const createProviderLabelMap = (t: (key: string) => string) => ({
	google: t("auth.oauthProviderGoogle"),
	naver: t("auth.oauthProviderNaver"),
	kakao: t("auth.oauthProviderKakao"),
});

export const buildGoogleOAuthUrl = (apiUrl: string | undefined, timestamp: number) =>
	`${apiUrl || "https://api.inflectco.com"}/oauth/google?t=${timestamp}`;
